import { FC, memo, useCallback } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { CtaBar } from 'modules/cta-bar'
import { Layout } from 'modules/layout'
import { buildSimulatorUrl } from 'utils/buildSimulatorUrl'
import { pushDataLayer } from 'utils/push-data-layer'

import Hero from './hero'

const Solutions = dynamic(() => import('./solutions'))
const Guarantee = dynamic(() => import('./guarantee'))
const Benefits = dynamic(() => import('./benefits'))
const HowWorks = dynamic(() => import('./how-works'))
const BoostsPlans = dynamic(() => import('./boosts-plans'))
const TakeNote = dynamic(() => import('./take-note'))
const Feedbacks = dynamic(() => import('modules/feedbacks'))
const Help = dynamic(() => import('./help'))

const LoanOnline: FC = memo(() => {
  const router = useRouter()

  const handleClick = useCallback(
    (clickTarget: string, label: string) => {
      pushDataLayer({
        category: 'Clique',
        action: 'Botões',
        label: `${clickTarget} - Empréstimo Online - ${label}`
      })

      location.href = buildSimulatorUrl(router.pathname, { medium: clickTarget + '-' + label })
    },
    [router.pathname]
  )

  return (
    <Layout hasCTA>
      <Hero onClick={() => handleClick('Banner', 'Simular agora')} />
      <Solutions />
      <Guarantee onClick={() => handleClick('O que é', 'Simular agora')} />
      <Benefits />
      <HowWorks onClick={() => handleClick('Como funciona', 'Simular agora')} />
      <BoostsPlans onClick={() => handleClick('Como usar', 'Simular agora')} />
      <TakeNote />
      <Feedbacks darkMode={true} />
      <Help />
      <CtaBar
        title="Simule agora o seu empréstimo"
        buttonLabel="Simular agora"
        onClick={() => handleClick('Flutuante', 'Simular agora')}
      />
    </Layout>
  )
})

LoanOnline.displayName = 'LoanOnline'

export default LoanOnline
